import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VDataTable,{staticStyle:{"cursor":"pointer"},attrs:{"headers":_vm.headers,"items":_vm.sessions,"loading":_vm.loader,"loading-text":"Загрузка... Ожидайте!","footer-props":{
        disableItemsPerPage: true,
        itemsPerPageText: ''
      }},scopedSlots:_vm._u([{key:"item.date",fn:function({item}){return [_c('b',[_vm._v(_vm._s(_vm.getDate(item.date)))])]}},{key:"item.ip_address",fn:function({item}){return [_vm._v(" "+_vm._s(item.ip_address)+" ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }